import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const RnMShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="R & M"
    sectionKey="R & M"
    backRoute="/sections/rnm"
  />
);

export default RnMShipmentRequest;
